import { render, staticRenderFns } from "./WxWorkListFilter.vue?vue&type=template&id=1a367982&scoped=true&"
import script from "./WxWorkListFilter.vue?vue&type=script&lang=js&"
export * from "./WxWorkListFilter.vue?vue&type=script&lang=js&"
import style0 from "./WxWorkListFilter.vue?vue&type=style&index=0&id=1a367982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a367982",
  null
  
)

export default component.exports